import {
  CommonModule,
  isPlatformServer,
  NgOptimizedImage,
} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  signal,
  DOCUMENT,
  inject,
  PLATFORM_ID,
} from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
})
export class ScrollToTopComponent {
  public windowScrolled = signal<boolean>(false);

  private readonly _document: Document = inject(DOCUMENT);
  private readonly _platformId = inject(PLATFORM_ID);

  @HostListener('window:scroll', [])
  public onWindowScroll(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    if (
      window.scrollY ||
      this._document.documentElement.scrollTop ||
      this._document.body.scrollTop > 100
    ) {
      this.windowScrolled.set(true);
    } else if (
      (this.windowScrolled && window.scrollY) ||
      this._document.documentElement.scrollTop ||
      this._document.body.scrollTop < 10
    ) {
      this.windowScrolled.set(false);
    }
  }

  public scrollToTop(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
